import { render } from "./산부인과.vue?vue&type=template&id=1dd6fe7d"
import script from "./산부인과.vue?vue&type=script&lang=js"
export * from "./산부인과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__